import { render } from "./silent-renew.vue?vue&type=template&id=6d54cd1a&scoped=true&ts=true"
import script from "./silent-renew.vue?vue&type=script&lang=ts"
export * from "./silent-renew.vue?vue&type=script&lang=ts"

import "./silent-renew.scss?vue&type=style&index=0&id=6d54cd1a&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d54cd1a"]])

export default __exports__